module.exports = __webpack_public_path__ + "img/logo-small.cd4c75da.svg";